export default __webpack_public_path__ + "static/media/docspoint.5699d990.svg";